
import { addDays } from 'date-fns'
import type { EntryValuesType } from '@/shared/types/other.types'

export const VISA = 'Visa'

export const entryValues: EntryValuesType[] = [
  {
    code: 'V30',
    title: 'up to 30 days',
    duration: 30,
  },
  {
    code: 'V60',
    title: 'up to 60 days',
    duration: 60,
  },
  {
    code: 'V90',
    title: 'up to 90 days',
    duration: 90,
  },
  // {
  //   id: 'V120',
  //   type: VISA,
  //   text: 'up to 120 days',
  //   addition: 120,
  // },
  // {
  //   id: 'V150',
  //   type: VISA,
  //   text: 'up to 150 days',
  //   addition: 150,
  // },
  {
    code: 'V180',
    title: 'up to 180 days',
    duration: 180,
  },
]

export const getEntryById = (id: string, durations: EntryValuesType[] = entryValues): EntryValuesType | undefined => 
  durations.find(entry => entry.code === id)


export const getDurationDate = (entryId: string, startDate: Date, durations: EntryValuesType[]): Date => {
  const entry = getEntryById(entryId, durations)
  return entry ? addDays(startDate, Number(entry.duration) - 1) : new Date()
}
